import React, { useState, useEffect } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';

import useExcelData from 'hooks/useExcelData';
import ExcelView from 'components/spreadsheet/ExcelView';

const PurchaseOrderLineEditModal = ({
  show,
  onHide,
  selectedItems,
  onSave,
}) => {
  const [isSaving, setIsSaving] = useState(false);
  const { data, setData, handleCellsChanged } = useExcelData([]);

  useEffect(() => {
    if (selectedItems && selectedItems.length > 0) {
      const formatedData = selectedItems.map(item => ({
        id: item.id,
        name: item.vendor_product?.product?.name || '',
        brand: item.vendor_product?.product?.brand?.name || '',
        vendor_sku: item.vendor_product?.vendor_sku || '',
        total_quantity: item.total_quantity || '',
        unit_price: item.unit_price || '',
        unit_discount_price: item.unit_discount_price || '',
      }));

      setData(formatedData);
    }
  }, [selectedItems, setData]);

  const columns = [
    { key: 'name', header: 'Name', disabled: true, width: 300 },
    { key: 'brand', header: 'Brand', disabled: true },
    { key: 'vendor_sku', header: 'Vendor SKU', disabled: true },
    { key: 'total_quantity', header: 'Total Quantity', type: 'number' },
    { key: 'unit_price', header: 'Unit Price', type: 'number' },
    {
      key: 'unit_discount_price',
      header: 'Unit Discount Price',
      type: 'number',
    },
  ];

  const handleSave = async () => {
    setIsSaving(true);

    try {
      const updatedItems = data.map(row => ({
        id: row.id,
        total_quantity: row.total_quantity,
        unit_price: row.unit_price,
        unit_discount_price: row.unit_discount_price,
      }));

      await onSave(updatedItems);
      onHide();
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} fullscreen={true}>
      <Modal.Header closeButton>
        <Modal.Title>Edit PO Lines</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {data.length === 0 ? (
          <div className="text-center py-4">
            <Spinner animation="border" />
          </div>
        ) : (
          <ExcelView
            data={data}
            columns={columns}
            onCellsChanged={handleCellsChanged}
          />
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleSave}
          disabled={isSaving || data.length === 0}
        >
          {isSaving ? 'Saving...' : 'Save Changes'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PurchaseOrderLineEditModal;
